<template>
    <div>
        <Header title="首页">
        </Header>
        <div class="my-white-mod">
            <div  class="new-mode" >
                <DatePicker  :open="open_three_day"  @on-change="changeThreeTime" confirm  format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 12px;">
                    <span @click="handleClick2" class="zhizhen"><Icon type="md-calendar" size="20"  />                             
                        <template v-if="(searchthree.start_day == '' && searchthree.end_day == '' )" >                        
                            <span style="padding-left:8px">
                                当月
                            </span>                        
                        </template>
                        <template v-else>{{ searchthree.start_day }}~ {{ searchthree.end_day }}</template>
                    </span>
                </DatePicker> 
                <Button @click="countTop" type="warning" style="margin-left:10px">搜索</Button>
            </div>
            <table id="top">
                <tr>
                    <td>
                        <div class="order-item"  v-if="three_top[1]">
                            <img src="../../assets/medal/2.png" />
                            <div>
                                <div class="sales-text-style">{{three_top[1].name}}</div>
                                <div class="order-money">￥{{three_top[1].money}}</div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="order-item"   v-if="three_top[0]">
                            <img src="../../assets/medal/1.png" />
                            <div>
                                <div class="sales-text-style">{{three_top[0].name}}</div>
                                <div class="order-money">￥{{three_top[0].money}}</div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="order-item"  v-if="three_top[2]">
                            <img src="../../assets/medal/3.png" />
                            <div>
                                <div class="sales-text-style">{{three_top[2].name}}</div>
                                <div class="order-money">￥{{three_top[2].money}}</div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div class="order-item"  v-if="three_top[3]">
                            <div class="sort-number">4</div>
                            <div>
                                <div class="sales-text-style">{{three_top[3].name}}</div>
                                <div class="order-money">￥{{three_top[3].money}}</div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="order-item"   v-if="three_top[4]">
                            <div class="sort-number">5</div>
                            <div>
                                <div class="sales-text-style">{{three_top[4].name}}</div>
                                <div class="order-money">￥{{three_top[4].money}}</div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="order-item"  v-if="three_top[5]">
                            <div class="sort-number">6</div>
                            <div>
                                <div class="sales-text-style">{{three_top[5].name}}</div>
                                <div class="order-money">￥{{three_top[5].money}}</div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <PayTimeOrder></PayTimeOrder>
        <MoneyOrder></MoneyOrder>
        <AfterOrder></AfterOrder>
        <div v-if="userInfo.user_id == 0">
            <!-- <div class="my-white-mod"   >
                <Row>
                    <Col class="bg_item" span="5" :style="`background-image: url(${bg1}) `">
                        <div class="font-left">
                            {{total.customer_count}}
                        </div>
                        <div class="font-right">
                            总客户数
                        </div>
                    </Col>
                    <Col class="bg_item" span="5" :style="`background-image: url(${bg2});`">
                        <div class="font-left">
                            {{total.today_add_customer_count}}
                        </div>
                        <div class="font-right">
                            今日客户数
                        </div>
                    </Col>
                    <Col class="bg_item" span="5" :style="`background-image: url(${bg3});`">
                        <div class="font-left">
                            {{total.total_deal_count}}
                        </div>
                        <div class="font-right">
                            总成交数
                        </div>
                    </Col>
                    <Col class="bg_item" span="5" :style="`background-image: url(${bg4});`">
                        <div class="font-left">
                            {{total.today_deal_count}}
                        </div>
                        <div class="font-right">
                            今日成交数
                        </div>
                    </Col>
                </Row>
            </div> -->
            <div class="my-white-mod" style="padding:10px 0;">
                <div class="deal_box">
                    <div class="deal_nav" style="">
                        <span style="font-weight: bold; font-size: 18px;">数据概览</span>  

                                       
                    </div>                    
                    <div class="deal_itm">   
                        <div class="time-center">
                            <div class="deal_heard_tittle">用户成交排名</div>
                            <DatePicker  :open="open_month" :value="dateArr" @on-change="changeTime" format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 12px;">
                                <span @click="handleClick" class="zhizhen"><Icon type="md-calendar" size="20"  />                             
                                    <template v-if="(searchdata.start_day == getTodayDate()&&searchdata.end_day==getTodayDate())||(searchdata.start_day == ''&&searchdata.end_day == '' )">今日</template>
                                    <template v-else>{{ searchdata.start_day }}~{{ searchdata.end_day }}</template>
                                </span>
                            </DatePicker>      
                        </div>                                            
                        <div >
                            <div style="width:430px">
                                <Table :columns="table2.columns" border height="500" :data="table2.data" :row-class-name="rowClassName"  @on-row-click="showOrder">
                                    <template slot-scope="{ index }" slot="index">
                                        <strong>{{ ((table2.page - 1) * table2.limit) + index +1 }}</strong>
                                    </template>
                                    <template slot-scope="{ row }" slot="remark" >
                                        <div >{{ row.name }}</div>
                                    </template>
                                </Table>
                                <Page :current="table2.page" :page-size="table2.limit" :total="table2.total"  simple   class="table-pages" @on-change="changeTable"/>
                            </div>                    
                        </div>
                    </div>                    
                    <div class="deal_itm">
                        <div class="time-center">
                            <div class="deal_heard_tittle">销售订单最高金额排名</div>
                            <DatePicker  :open="open_month1" :value="dateArr" @on-change="changeTime1" format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 12px;">
                                <span @click="handleClick1" class="zhizhen"><Icon type="md-calendar" size="20"  />                             
                                    <template v-if="(searchdata1.start_day == getTodayDate()&&searchdata1.end_day==getTodayDate())||(searchdata1.start_day == ''&&searchdata1.end_day == '' )">今日</template>
                                    <template v-else>{{ searchdata1.start_day }}~{{ searchdata1.end_day }}</template>
                                </span>
                            </DatePicker>  
                        </div>
                        <div style="width:550px">
                            <Table :columns="table2.columns1"  border height="500" :data="table2.data1" :row-class-name="rowClassName"  @on-row-click="toOrder">
                                <template slot-scope="{ index }" slot="index">
                                    <strong>{{ ((table2.page1 - 1) * table2.limit) + index +1 }}</strong>
                                </template>
                            </Table>
                            <Page :current="table2.page1" :page-size="table2.limit" :total="table2.total1"  simple   class="table-pages" @on-change="changeTable1"/>
                        </div> 
                    </div>
                    <div class="deal_itm">
                        <div class="time-center">
                            <div class="deal_heard_tittle">单均价排名</div>
                            <DatePicker  :open="open_month2" :value="dateArr" @on-change="changeTime2" format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 12px;">
                                <span @click="handleClick_2" class="zhizhen"><Icon type="md-calendar" size="20"  />                             
                                    <template v-if="(searchdata2.start_day == getTodayDate()&&searchdata2.end_day==getTodayDate())||(searchdata2.start_day == ''&&searchdata2.end_day == '' )">今日</template>
                                    <template v-else>{{ searchdata2.start_day }}~{{ searchdata2.end_day }}</template>
                                </span>
                            </DatePicker>  

                        </div>
                        <div style="width:500px">
                            <Table :columns="table2.columns2"  border height="500" :data="table2.data2">
                                <template slot-scope="{ index }" slot="index">
                                    <strong>{{ ((table2.page2 - 1) * table2.limit) + index +1 }}</strong>
                                </template>
                            </Table>
                                <Page :current="table2.page2" :page-size="table2.limit" :total="table2.total2"  simple   class="table-pages" @on-change="changeTable2"/>
                        </div> 
                    </div>                   
                </div>
            </div>
            <div class="my-white-mod" style="padding:10px 0;">
                <div class="deal_nav" style="">
                    <div>
                        <span style="font-weight: bold; font-size: 18px;">续费率</span>  
                        <DatePicker type="month" format="yyyy-MM" @on-change="changeStartMonth"  placeholder="请选择开始月份" style="width: 150px;margin-left: 12px;"></DatePicker>
                        ~
                        <DatePicker type="month" format="yyyy-MM"  @on-change="changeEndMonth"  placeholder="请选择结束月份" style="width: 150px;"></DatePicker>
                        <Button @click="goSearch" type="warning" style="margin-left:10px">搜索</Button>
                    </div>      
                    <div class="felx_sta_sta">                                 
                        <div class="circle_cla" style="margin-top:20px">
                            <i-circle :percent="(getRenewNum() || 0)*1" :size="160">
                                <span class="demo-Circle-inner" style="font-size:20px">{{getRenewNum()}}%</span>
                            </i-circle>
                        </div> 
                        <div style="margin-top:40px;margin-left: 24px;">
                            <div class="felx_sta_sta"> 
                                <div class="text_box"> 过期订单总数：{{ renewFormdata.normal_order_count }}</div>
                                <div class="text_box"> 过期订单金额：{{ renewFormdata.normal_order_money }}</div>
                            </div>
                            <div class="felx_sta_sta" style="margin-top:12px"> 
                                <div class="text_box"> 续费订单总数：{{ renewFormdata.renew_order_count }}</div>
                                <div class="text_box"> 续费订单金额：{{ renewFormdata.renew_order_money }}</div>
                            </div>
                        </div> 
                    </div> 
                </div>  
            </div>
        </div>
        
        <div v-else >
            <div class="my-white-mod" style="min-height:500px;padding-bottom:30px" >
                <h1 style="margin-top:30px">{{total.team_name}}</h1>
                <Row>
                    <Col class="bg_item" span="5" :style="`background-image: url(${bg2});`">
                        <div class="font-left">
                            {{total.team_complete_money}}
                        </div>
                        <div class="font-right">
                            本月成交金额
                        </div>
                    </Col>
                    <Col class="bg_item" span="5" :style="`background-image: url(${bg3});`">
                        <div class="font-left">
                            {{total.teams_member_money}}
                        </div>
                        <div class="font-right">
                            本月目标金额
                        </div>
                    </Col>
                    <Col class="bg_item" span="5" :style="`background-image: url(${bg4});`">
                        <div class="font-left">
                            {{total.team_complete}}%
                        </div>
                        <div class="font-right">
                            目标完成度
                        </div>
                    </Col>
                </Row>
                <div style="margin-top:30px;display: flex;align-items: center;">
                    <h1 >个人</h1><DatePicker type="month"  placement="bottom-end" placeholder="选择月份" style="margin-left:20px"  @on-change="change_month"></DatePicker>
                
                </div>
                <div style="display:flex;margin-top:10px">
                    <div >
                        <div style="display:flex;margin-bottom:10px">
                            <Col class="bg_item" span="5" :style="`background-image: url(${bg1});flex:unset;max-width:unset `">
                                <div class="font-left">
                                    {{total.today_pay_money}}
                                </div>
                                <div class="font-right">
                                    今日成交金额
                                </div>
                            </Col>
                            <Col class="bg_item" span="5" :style="`background-image: url(${bg2});flex:unset;max-width:unset`">
                                <div class="font-left">
                                    {{total.month_pay_money}}
                                </div>
                                <div class="font-right">
                                    本月成交金额
                                </div>
                            </Col>
                        </div>
                        
                        <div  style="display:flex">
                            <Col class="bg_item" span="5" :style="`background-image: url(${bg3});flex:unset;max-width:unset`">
                                <div class="font-left">
                                    {{total.target_money}}
                                </div>
                                <div class="font-right">
                                    本月目标金额
                                </div>
                            </Col>
                            <Col class="bg_item" span="5" :style="`background-image: url(${bg4});flex:unset;max-width:unset`">
                                <div class="font-left">
                                    {{total.complete}}%
                                </div>
                                <div class="font-right">
                                    目标完成度
                                </div>
                            </Col>
                        </div>
                    </div>
                    <div>
                        <Table style="width:400px" border  height="350" :loading="table.loading"   :columns="table.columns" :data="total.return_month_data"></Table>
                    </div>
                </div>
                
            </div>
        </div>
        <Modal v-model="show_order" title="订单列表" width="600">
        
            <Table :columns="order_table.columns" :data="order_table.data" >
            </Table>
            <Page :current="order_table.page" :page-size="order_table.limit" :total="order_table.total"  style="text-align:right;margin-top: 10px;"  />
            <div slot="footer"></div>
        </Modal>
    </div>

</template>
<script>
import {Header} from "@/components/mainLayout"
import {PayTimeOrder, MoneyOrder, AfterOrder} from "@/components/statistics"
import { daily_list,renew_sum, daily_list_best, daily_list_rate,order_list, count_top_three } from "@/api/statistics"
import {home_index} from "@/api/system"
export default {
    components:{ 
        Header,
        PayTimeOrder,
        MoneyOrder,
        AfterOrder
    },
    data(){
        return{
            show_order:false,
            search_month:"",
            open_month:false,
            open_month1:false,
            open_month2:false,
            total:{},
            bg1: require("../../assets/31.png"),
            bg2: require("../../assets/32.png"),
            bg3: require("../../assets/33.png"),
            bg4: require("../../assets/34.png"),
            userInfo:{},
            dateArr: [],
            month:'',
            table:{
                loading:false,
                columns: [
                    {
                        title: '日期',
                        align:'center',
                        key: 'day'
                    },
                    {
                        title: '金额',
                        align:'center',
                        key: 'money'
                    },
                ]
            },
            order_table:{
                customer_id:0,
                page:1,
                limit:20,
                data:[],
                total:0,
                columns: [
                    {
                        title: 'ID',
                        align:'center',
                        key: 'id'
                    },
                    {
                        title: '销售',
                        align:'center',
                        key: 'department_member_name'
                    },
                    {
                        title: '金额',
                        align:'center',
                        key: 'pay_money'
                    },
                    {
                        title: '成交时间',
                        align:'center',
                        width:180,
                        key: 'pay_time',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style:{color:'#515a6e'}
                                }, params.row.pay_time ? params.row.pay_time.replace("T", " "): "")
                            ]);

                        }
                    },
                    {
                        title: '操作',
                        align:'center',
                        width:100,
                        key: 'pay_time',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            let routeUrl = this.$router.resolve({
                                                path: '/customerpool/info',
                                                query: {
                                                    order_id: params.row.id,
                                                    customer_id:params.row.customerId,
                                                    type:2
                                                }
                                            });
                                            window.open(routeUrl.href, '_blank');
                                        }
                                    }
                                }, '详情')
                            ]);

                        }
                    },
                ]

            },
            table2:{
                columns: [
                    {
                        title: '排名',
                        width:70,
                        align:'center',
                        slot: 'index'
                    },
                    {
                        title: '用户',
                        align:'center',
                        width:160,
                        slot: 'remark'
                    },
                    {
                        title: '订单数',
                        align:'center',
                        key: 'pay_num'
                    },
                    {
                        title: '销售额',
                        align:'center',
                        key: 'pay_money'
                    }
                ],
                columns1: [
                    {
                        title: '排名',
                        // width:70,
                        align:'center',
                        slot: 'index'
                    },
                    {
                        title: '单号',
                        // width:70,
                        align:'center',
                        key: 'id'
                    },
                    {
                        title: '销售',
                        align:'center',
                        width:200,
                        key: 'name'
                    },
                    {
                        title: '单价',
                        align:'center',
                        key: 'pay_money'
                    },
                    {
                        title: '成交时间',
                        width:110,
                        align:'center',
                        key: 'pay_time'
                    }
                ],
                columns2: [
                    {
                        title: '排名',
                        width:70,
                        align:'center',
                        slot: 'index'
                    },
                    {
                        title: '销售',
                        // width:200,
                        align:'center',
                        key: 'name'
                    },
                    
                    {
                        title: '单均价',
                        align:'center',
                        key: 'rate'
                    },
                    {
                        title: '单量',
                        align:'center',
                        key: 'num'
                    },
                    {
                        title: '总销售额',
                        align:'center',
                        key: 'money'
                    }
                ],
                total:0,
                limit:20,
                page:1,
                total1:0,
                page1:1,
                total2:0,
                page2:1,
                data: [],
                data1: [],
                data2: [],
                
            },
            searchdata:{
                start_day:'',
                end_day:''
            },
            searchdata1:{
                start_day:'',
                end_day:''
            },
            searchdata2:{
                start_day:'',
                end_day:''
            },
            searchMonth :{
                start_month: '',
                end_month: ''
            },
            renewFormdata:{
                normal_order_count: 0,
                normal_order_money:0,
                renew_order_count:0,
                renew_order_money:0,
            },
            searchthree:{
                start_day:'',
                end_day:''
            },
            three_top:[
                {money:0, name:""},
                {money:0, name:""},
                {money:0, name:""},
            ],
            open_three_day:false,
        }
    },
    mounted(){
        this.userInfo = this.$store.state.userInfo
        this.search_month = this.getTodayDate()
        this.get_index();
        this.daily_list() 
        this.daily_rate()
        this.daily_best()
        this.renew_sum()    
        this.countTop()   
    },
    methods:{
        rowClassName (row, index) {
                return 'demo-table-cursor-row';
        },
        changeStartMonth(e){
            if(e){
                this.searchMonth.start_month = e
            }else{
                this.searchMonth.start_month = e
            }
        },
        changeEndMonth(e){
            if(e){
                this.searchMonth.end_month = e
            }else{
                this.searchMonth.end_month = e
            }
        },
        goSearch(){
            if(!((!this.searchMonth.start_month&&!this.searchMonth.end_month)||(this.searchMonth.start_month&&this.searchMonth.end_month))){
                this.$Message.error('请选择月份')
                return
            }
            var start_date = new Date(this.searchMonth.start_month);
            var end_date = new Date(this.searchMonth.end_month);
            if(end_date.getTime() < start_date.getTime()){
                this.$Message.error('结束月份不能大于开始月份')
                return ;
            }
            this.renew_sum()
        },  
        getRenewNum(){
            if(this.renewFormdata.normal_order_count){
                let a = ((this.renewFormdata.renew_order_count/this.renewFormdata.normal_order_count)*100).toFixed(2)
                return a
            }else{
                return 100
            }

        },
        renew_sum(){
            renew_sum(this.searchMonth).then(res=>{
                this.renewFormdata.normal_order_count = res.data.normal_order_count //过期订单总数
                this.renewFormdata.normal_order_money = res.data.normal_order_money //过期订单金额
                this.renewFormdata.renew_order_count = res.data.renew_order_count //续费订单总数
                this.renewFormdata.renew_order_money = res.data.renew_order_money  //续费订单金额               
            })
        },
        daily_list(){
            this.open_month = false
            this.searchdata.limit = this.table2.limit
            this.searchdata.page = this.table2.page
            daily_list(this.searchdata).then(res=>{
                this.table2.data = res.data.data //用户成交排名
                this.table2.total = res.data.total //用户成交排名
                // this.table2.data1 = res.data.best  //销售订单最高金额排名
                // this.table2.data2 = res.data.rate //单均价排名
            })
        },
        daily_best(){
            this.open_month1 = false
            this.searchdata1.limit = this.table2.limit
            this.searchdata1.page = this.table2.page1
            daily_list_best(this.searchdata1).then(res=>{
                this.table2.data1 = res.data.data //用户成交排名
                this.table2.total1 = res.data.total //用户成交排名
                // this.table2.data1 = res.data.best  //销售订单最高金额排名
                // this.table2.data2 = res.data.rate //单均价排名
            })
        },
        daily_rate(){
            this.open_month2 = false
            this.searchdata2.limit = this.table2.limit
            this.searchdata2.page = this.table2.page2
            daily_list_rate(this.searchdata2).then(res=>{
                this.table2.data2 = res.data.data //用户成交排名
                this.table2.total2 = res.data.total //用户成交排名
                // this.table2.data1 = res.data.best  //销售订单最高金额排名
                // this.table2.data2 = res.data.rate //单均价排名
            })
        },
        changeTable(index){
            this.table2.page = index
            this.daily_list()
        },
        changeTable1(index){
            this.table2.page1 = index
            this.daily_best()
        },
        changeTable2(index){
            this.table2.page2 = index
            this.daily_rate()
        },
        changeTime(e){
            if(e[0]){                
                this.searchdata.start_day = e[0]
                this.searchdata.end_day = e[1]
            }else{
                this.searchdata.start_day = ''
                this.searchdata.end_day = ''                
            }
            this.daily_list()
        },
        changeTime1(e){
            if(e[0]){                
                this.searchdata1.start_day = e[0]
                this.searchdata1.end_day = e[1]
            }else{
                this.searchdata1.start_day = ''
                this.searchdata1.end_day = ''                
            }
            this.daily_best()
        },
        changeTime2(e){
            if(e[0]){                
                this.searchdata2.start_day = e[0]
                this.searchdata2.end_day = e[1]
            }else{
                this.searchdata2.start_day = ''
                this.searchdata2.end_day = ''                
            }
            this.daily_rate()
        },
        handleClick(){
            this.open_month = !this.open_month
        },
        handleClick1(){
            this.open_month1 = !this.open_month1
        },
        handleClick_2(){
            console.log(1)
            this.open_month2 = !this.open_month2
            console.log(this.open_month2)
        },
        //获取当前日期函数
        getTodayDate() {
            let date = new Date(),
                year = date.getFullYear(), //获取完整的年份(4位)
                month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
                strDate = date.getDate() // 获取当前日(1-31)
            if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
            if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0
            
            return `${year}-${month}-${strDate}`
        },

        handleChange(date){
            if(date){
                this.search_month = date;
            }else{
                this.search_month = this.getTodayDate()
                this.daily()
            } 
            // this.search_month = date;
        },
        
        handleClear () {
                this.open_month = false;
        },
        handleOk () {
            this.open_month = false;
            this.daily()
        },
        change_month(e){
            this.month = e
            this.get_index()
        },
        get_index(){
            this.table.loading = true
            let val = {};
            if(this.month != "") {
                val.month = this.month
            }
            home_index(val).then(res=>{
                this.table.loading = false
                if (res.code == 200) {
                    this.total = res.data;
                } else {
                    this.$Message.error(res.msg)
                }

            }).catch(err=>{
                this.table.loading = false
            })
        },
        showOrder(r){
            this.show_order = true
            this.order_table.customer_id = r.id
            this.getOrderList()
        },
        toOrder(row){
            
            let routeUrl = this.$router.resolve({
                path: '/customerpool/info',
                query: {
                    order_id: row.id,
                    customer_id:row.customer_id,
                    type:2
                }
            });
            window.open(routeUrl.href, '_blank');
        },
        getOrderList(){
            let post = {
                start_day:this.searchdata.start_day,
                end_day:this.searchdata.end_day,
                customer_id:this.order_table.customer_id,
                page:this.order_table.page,
                limit:this.order_table.limit
            }
            order_list(post).then(res=>{
                this.order_table.data = res.data
                this.order_table.total = res.total
                console.log(this.order_table)
            })
        },
        changeThreeTime(e){
            if(e[0]){                
                this.searchthree.start_day = e[0]
                this.searchthree.end_day = e[1]
            }else{
                this.searchthree.start_day = ''
                this.searchthree.end_day = ''                
            }
            this.open_three_day = false
        },
        handleClick2(){
            this.open_three_day = !this.open_three_day
        },
        countTop(){
            count_top_three(this.searchthree).then(res=>{
                    this.three_top = res.data
            })
        },
    }
}
</script>

<style>

.demo-table-cursor-row{
    cursor: pointer!important;
}
</style>
<style scoped>
.zhizhen {
    cursor: pointer;
}
.felx_sta_sta {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}
.text_box {
    width:200px
}
    .deal_box {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-flow: wrap;
        padding-bottom: 30px;
    }
    .deal_nav {
        width:100%;
        padding: 10px 30px; 

    }
    .deal_itm {
        flex: 1;        
        padding-left:10px;
        margin: 10px 20px;
    }
    
    .deal_heard_tittle {
        font-size: 16px;
    }
    .circle_cla {
        text-align: center;
        width:180px;
    }
    .ivu-row{
        margin:30px 0
    }
    .ivu-row .ivu-col{
        background-repeat: no-repeat;
        background-position:center;
        color:#ffffff;
        font-weight: bold;
    }
    .bg_item{
        padding: 40px 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 0 20px;
        border-radius: 5%;
        width:308px;
        height:171px;
        color:#fff;
    }
    .font-left{
        font-size:41px;text-align: left;
    }
    .font-right{
        font-size:20px;text-align: right;
    }
    .time-center{
        display: flex;align-content: center;
        padding-bottom: 16px;
    }
    .table-pages{
        float:right;margin-top:10px
    }
    .order-item{
        text-align:center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size:25px
    }
    .order-item img{
        margin-right:5px;
        width:80px;
        height:80px;
    }
    .new-mode{
        border-bottom:1px solid #ddd;
        margin-bottom:15px;
        padding-bottom:15px
    }
    .sort-number{
        font-size: 40px;
        font-weight: bold;
        border: 3px solid #445E87FF;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right:10px;
    }
    #top td{
        padding:30px
    }
</style>
